import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconTruck from '@/icons/Truck.svg';
import { SHIPMENT_CARRIERS } from '@/models/shipment';

export const ShipmentHandoverCompletedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'shipment_handover_completed'>;
}) => {
  const carrierName =
    SHIPMENT_CARRIERS.find((c) => c.id === activity.shipment.carrier)?.name ??
    activity.shipment.carrier ??
    '';

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconTruck />}
      message={
        <BaseActivityText>
          {activity.shipment.carrier === 'private-carrier' ? (
            <Trans id="activities.shipment_handover_completed.private_carrier.message">
              <strong>A private carrier</strong> handled the shipment
            </Trans>
          ) : (
            <Trans id="activities.shipment_handover_completed.message">
              <strong>{carrierName}</strong> handled the shipment
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
